var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('AudioIcon'),_c('LevelStart',{attrs:{"title":_vm.title,"name":_vm.name,"forwardPath":_vm.forwardPath}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }